import { render, staticRenderFns } from "./spm-template.vue?vue&type=template&id=224c8e00&scoped=true"
import script from "./spm-template.vue?vue&type=script&lang=js"
export * from "./spm-template.vue?vue&type=script&lang=js"
import style0 from "./spm-template.vue?vue&type=style&index=0&id=224c8e00&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c8e00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('224c8e00')) {
      api.createRecord('224c8e00', component.options)
    } else {
      api.reload('224c8e00', component.options)
    }
    module.hot.accept("./spm-template.vue?vue&type=template&id=224c8e00&scoped=true", function () {
      api.rerender('224c8e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/spm/spm-template/spm-template.vue"
export default component.exports